import React from "react";
import { FileText, FileSpreadsheet, Presentation, File as FileIcon, FileArchive, Download } from "lucide-react";
import { API_BASE } from "../lib/api";

const ICONS = {
  pdf: FileText,
  doc: FileText,
  sheet: FileSpreadsheet,
  slides: Presentation,
  zip: FileArchive,
  file: FileIcon,
};

function fmtBytes(n) {
  if (!n && n !== 0) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/** Renders an attachment (image inline, other kinds → download chip). */
export default function AttachmentPreview({ attachment, compact = false }) {
  if (!attachment) return null;
  const url = attachment.url?.startsWith("/api")
    ? `${API_BASE}${attachment.url.slice(4)}`
    : attachment.url;
  const isImage = attachment.kind === "image";
  if (isImage) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`attachment-image-${attachment.id}`}
        className="block"
      >
        <img
          src={url}
          alt={attachment.filename}
          className={`border border-[color:var(--sat-cyan)] ${compact ? "max-h-40" : "max-h-72"} object-contain block`}
        />
      </a>
    );
  }
  const Icon = ICONS[attachment.kind] || FileIcon;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`attachment-file-${attachment.id}`}
      className="inline-flex items-center gap-2 border border-[color:var(--sat-cyan)] px-3 py-2 hover:bg-[color:var(--sat-cyan)] hover:text-black transition-colors group"
      download={attachment.filename}
    >
      <Icon size={16} className="sat-cyan group-hover:text-black" />
      <div className="flex flex-col text-left leading-tight">
        <span className="font-mono text-[11px] uppercase tracking-wider truncate max-w-[220px]">
          {attachment.filename}
        </span>
        <span className="font-mono text-[9px] text-[color:var(--sat-text-dim)] group-hover:text-black">
          .{attachment.ext} · {fmtBytes(attachment.size)}
        </span>
      </div>
      <Download size={12} className="ml-1 opacity-60 group-hover:opacity-100" />
    </a>
  );
}
